module.exports = __webpack_public_path__ + "static/media/Wire Fraud Tips Video v2.docx.32d010ac.";